module.exports = __webpack_public_path__ + "components/flag/static/square/mw-2c2cc5da9655aefcfb9ced0deeda906b.svg";